export const getDiscountPercentage = (item = {}) => {
  const price = Number(item.price) || 0;
  const amount = getDiscountAmount(item);
  if (amount > 0 && price > 0) return Math.round((amount / price) * 100);

  const value = Number(
    item.discountPercentage ?? item.discountPercent ?? item.discountRate ?? 0,
  );
  return Number.isFinite(value) ? Math.min(100, Math.max(0, value)) : 0;
};

export const getDiscountAmount = (item = {}) => {
  const price = Number(item.price) || 0;
  const rawAmount = item.discountAmount ?? item.discountValue ?? item.discount;
  const value = Number(rawAmount);
  if (rawAmount != null && Number.isFinite(value)) {
    return Math.min(price, Math.max(0, value));
  }

  const rawFinalPrice =
    item.discountPrice ?? item.finalPrice ?? item.discountedPrice;
  const finalPrice = Number(rawFinalPrice);
  if (
    rawFinalPrice != null &&
    Number.isFinite(finalPrice) &&
    finalPrice >= 0 &&
    finalPrice < price
  ) {
    return Math.min(price, Math.max(0, price - finalPrice));
  }

  return 0;
};

export const getFinalPrice = (item = {}) => {
  const price = Number(item.price) || 0;
  const rawFinalPrice =
    item.discountPrice ?? item.finalPrice ?? item.discountedPrice;
  const explicitFinalPrice = Number(rawFinalPrice);
  if (
    rawFinalPrice != null &&
    Number.isFinite(explicitFinalPrice) &&
    explicitFinalPrice >= 0 &&
    explicitFinalPrice < price
  ) {
    return explicitFinalPrice;
  }
  const discountAmount = getDiscountAmount(item);
  if (discountAmount > 0) return price - discountAmount;
  return price * (1 - getDiscountPercentage(item) / 100);
};
